import MiniCart from '@assets/components/miniCart';
import calculate from '../utils/calculate';

const math = require('../utils/math');
const progress = require('../components/progress');

export default class extends MiniCart {
  constructor() {
    super();
    this.maxvalue = 200;
    this.input = '.input-quantity';
    this.$miniCart = $('.minicart');
    this.$popover = $('.popover');
  }

  init() {
    super.init();
    this.handlerUpdateQuantity();
    this.initValuesForProgressBar();
  }

  handlerUpdateQuantity() {
    this.$miniCart.on('mouseenter focusin touchstart', () => {
      const obs = new MutationObserver((e) => {
        this.$popover.each((index, element) => {
          const inputCounterMiniCart = this.$popover.find(this.input);

          math.default.update(inputCounterMiniCart, this.maxvalue);
        });
      });

      this.$popover.each((index, element) => {
        obs.observe(element, {
          childList: true,
          subtree: true
        });
      });
    });
  }

  initValuesForProgressBar() {
    $('.minicart').on('mouseenter focusin touchstart change count:update', () => {
      setTimeout(() => {
        const $shippingContainer = $('.progress-container');
        const $miniCart = $('.minicart .minicart-subtotal');
        const $valueShipping = $shippingContainer.find('.value-shipping').data('value');

        if ($shippingContainer.length > 0) {
          if (!$miniCart.attr('value')) return;
          const formatValueSubTotal = parseFloat($miniCart.attr('value').replace('€', '').replace(',', '.').trim());
          const subTotals = calculate.progress(formatValueSubTotal, $valueShipping);
          progress.default.build(subTotals, formatValueSubTotal, $('.minicart'));
        }
        progress.default.handlerUpdateProgress($miniCart);
      }, 1500);
    });
  }
}
